<template>
  <div>
    <base-header class="pb-6" type="primary">
      <breadcrumb-header :items="breadcrumb"></breadcrumb-header>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="row">
      </div>
    </div>
  </div>
</template>

<script>
import BreadcrumbHeader from "@/views/Store/Layout/BreadcrumbHeader";

export default {
  name: 'PartnerAdd',
  components: {
    BreadcrumbHeader,
  },
  computed: {
    breadcrumb() {
      return [
        {title: 'Klienci', link: {name: 'clients'}},
        {title: 'Partnerzy', link: {name: 'partner-list'}},
        {title: 'Nowy partner'}
      ];
    },
  },
};
</script>
